import { render, staticRenderFns } from "./genre-grid-tile.vue?vue&type=template&id=21c7a540&scoped=true"
import script from "./genre-grid-tile.vue?vue&type=script&lang=js"
export * from "./genre-grid-tile.vue?vue&type=script&lang=js"
import style0 from "./genre-grid-tile.vue?vue&type=style&index=0&id=21c7a540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7a540",
  null
  
)

export default component.exports